// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__wHLM4","title":"Header_title__UVQgC","side":"Header_side__3tBRo"};